import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { ExperienceProvider } from "./shared/context/ExperienceContext";

import Header from "./shared/components/layout/Header/Header";
import Footer from "./shared/components/layout/Footer/Footer";

import ThemeSwitch from "./shared/components/ui/ThemeSwitch/ThemeSwitch";
import ScrollToTop from "./shared/components/ScrollToTop/ScrollToTop";
import GlobalScrollReveal from "./shared/components/ScrollReveal/GlobalScrollReveal";
import ExperienceWelcomeModal from "./shared/components/ExperienceWelcomeModal/ExperienceWelcomeModal";
import WelcomeTypingIntro from "./shared/components/WelcomeTypingIntro/WelcomeTypingIntro";

import HomePage from "./modules/public/home/homePage";
import AboutPage from "./modules/public/about/aboutPage";
import SpacePage from "./modules/public/spaceClinic/EspacoPage";
import NotFoundPage from "./modules/public/notFound/NotFoundPage";
import LinksPage from "./modules/public/links/LinksPage";

import "./App.css";

const WELCOME_STORAGE_KEY = "experience-welcome-seen";

const PUBLIC_ROUTES_WITH_LAYOUT = ["/", "/about", "/space"];

function shouldShowWelcomeExperience() {
  if (typeof window === "undefined") return false;

  return window.localStorage.getItem(WELCOME_STORAGE_KEY) !== "true";
}

function AppLayout() {
  const location = useLocation();

  const shouldShowWelcome = shouldShowWelcomeExperience();

  const [showWelcomeBackdrop, setShowWelcomeBackdrop] =
    useState(shouldShowWelcome);

  const [isBackdropLeaving, setIsBackdropLeaving] = useState(false);

  const [showTypingIntro, setShowTypingIntro] = useState(shouldShowWelcome);
  const [allowWelcomeModal, setAllowWelcomeModal] = useState(false);

  const isKnownLayoutRoute = PUBLIC_ROUTES_WITH_LAYOUT.includes(
    location.pathname
  );

  const handleTypingIntroFinish = () => {
    setShowTypingIntro(false);
    setAllowWelcomeModal(true);
  };

  const handleWelcomeModalComplete = () => {
    setAllowWelcomeModal(false);
    setIsBackdropLeaving(true);

    window.setTimeout(() => {
      setShowWelcomeBackdrop(false);
      setIsBackdropLeaving(false);
    }, 420);
  };

  return (
    <>
      {showWelcomeBackdrop && (
        <div
          className={`app-welcome-backdrop ${
            isBackdropLeaving ? "is-leaving" : ""
          }`}
          aria-hidden="true"
        />
      )}

      {showTypingIntro && (
        <WelcomeTypingIntro onFinish={handleTypingIntroFinish} />
      )}

      <ExperienceWelcomeModal
        enabled={allowWelcomeModal}
        openDelay={220}
        onComplete={handleWelcomeModalComplete}
      />

      <GlobalScrollReveal />

      <ScrollToTop />

      {isKnownLayoutRoute && <Header />}
      {isKnownLayoutRoute && <ThemeSwitch />}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/space" element={<SpacePage />} />
        <Route path="/links" element={<LinksPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {isKnownLayoutRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <ExperienceProvider>
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </ExperienceProvider>
  );
}

export default App;